import React, {useContext, useState} from "react"
import Typography from "./Typography/Typography"
import Image from "next/image"
import Plan from "../bikeDetails/plan/Plan"
import PriceFilter from "../filter/PriceFilter/PriceFilter"
import {useTranslation} from "next-i18next"
import CheckoutContext from "../../context/CheckoutContext"
import {CollectionName} from "../../constants"
import AnalyticsContext from "../../context/AnalyticsContext"
import {gaCategories, gaEvents} from "../../config/googleAnalytics/events"
import ReusableRangeFilter from "../filter/ReusableRangeFilter"
import DataContext from "../../context/DataContext"
import urlParams from "../../utility/UrlParams"

type Props = {
	productsPriceRange: any,
	collectionName: CollectionName
	customUrlBaseValue?: string
}
function VerticalSectionPlanFilters({customUrlBaseValue, collectionName, productsPriceRange}:Props) {
	const {t} = useTranslation()
	const [isPlanOpen, setIsPlanOpen] = useState(true)
	const [priceRange, setPriceRange] = useState("CHF 0")
	const {data} = useContext(CheckoutContext)
	const planLength = data?.planLength || 36
	const {reactGA} = useContext(AnalyticsContext)
	const {pageProps, bikeFilters} = useContext(DataContext)
	const {maxWeightRange, rangeInterval} = pageProps
	const [maxWeight, setMaxWeight] = useState(maxWeightRange && maxWeightRange?.split("-")?.[0] !== "undefined" ? Number(maxWeightRange?.split("-")?.[0] || 0) : 0)
	const [range, setRange] = useState(rangeInterval && rangeInterval?.split("-")?.[0] !== "undefined" ? Number(rangeInterval?.split("-")?.[0] || 0) : 0)

	const getPriceRangeHandler = (values: any) => {
		const result = `CHF ${(values[0] / planLength).toFixed()}-${(values[1] / planLength).toFixed()}`
		setPriceRange(result)
	}

	return (<div className="my-plan-wrapper">
		{isPlanOpen ? <>
			<div className="d-flex justify-content-between align-items-center cursor-pointer"
				onClick={() => setIsPlanOpen(false)}>
				<Typography variant="bodyLgBold"
					onClick={() => {
						reactGA?.event({
							category: gaCategories.homePage,
							action: gaEvents.myPlanGreySection,
							label: `${gaEvents.myPlanGreySection}`,
							nonInteraction: false
						})
					}}
					semanticTag="span">
					{t("my-plan")}
				</Typography>
				<Image src={"/assets/icons/chevron-up-icon.svg"}
					width={16}
					height={16}
					alt={"chevron up"}
					objectFit={"contain"} />
			</div>

			<div className="px-0 mb-3 mt-2 border-bottom"
				style={{
					paddingBottom: 12
				}}>
				<Typography variant="bodySmBold"
					semanticTag="span"
					className={"col-md-12 col-lg-auto"}>
					{t("Laufzeit")}
				</Typography>
				<Typography variant="bodySm"
					semanticTag="span"
					className="ms-1 text-lowercase"
					style={{
						color: "#6C7074"
					}}>
                        ({t("Monate")})
				</Typography>
				<div className="col-12 mt-2">
					<Plan payOneTime
						hidePayOneTimeLabel
						hideOneTimePaymentCheckBox={false} />
				</div>
			</div>
			<div className="px-0">
				<Typography variant="bodySmBold"
					semanticTag="div"
					className={"col-md-12 col-lg-auto mb-1"}>
					{t("Preis")}, CHF
				</Typography>
				<div className={"col-12 pb-3"}>
					<PriceFilter customUrlBaseValue={customUrlBaseValue}
						collectionName={collectionName}
						productsPriceRange={productsPriceRange}
						getPriceRange={getPriceRangeHandler} />
				</div>
			</div>

			<div className="px-0">
				<Typography variant="bodySmBold"
					semanticTag="div"
					className={"col-md-12 col-lg-auto mb-1"}>
					{bikeFilters.find(filter => filter.slug === urlParams.maxWeight)?.name}
				</Typography>
				{maxWeightRange && maxWeightRange?.split("-")?.[0] !== "undefined" ? <div className={"col-12 pb-3"}>
					<ReusableRangeFilter
						inputLabel="minimum-weight"
						shouldUseZero
						collectionName={collectionName}
						param={"max_weight"}
						value={maxWeight}
						setValue={setMaxWeight}
						range={maxWeightRange}
					/>
				</div> : null}
			</div>

		</> : <>
			<div className="d-flex justify-content-between align-items-center cursor-pointer"
				onClick={() => setIsPlanOpen(true)}>
				<Typography variant="bodyLgBold"
					onClick={() => {
						reactGA?.event({
							category: gaCategories.homePage,
							action: gaEvents.myPlanGreySection,
							label: `${gaEvents.myPlanGreySection}`,
							nonInteraction: false
						})
					}}
					semanticTag="span">
					{t("my-plan")}
				</Typography>
				<Image src={"/assets/icons/edit-icon.svg"}
					width={20}
					height={20}
					alt={"edit"} />
			</div>
			<div className="d-flex d-md-block justify-content-between mt-2"
				style={{
					color: "#6C7074"
				}}>
				<div>
					<Typography variant="bodySmBold"
						semanticTag="h4"
						className={"mb-0"}>
						{t("Laufzeit")}
					</Typography>
					<Typography variant="bodySm"
						semanticTag="span"
						className="text-lowercase">
						{`${planLength} ${t("Monate")}`}
					</Typography>
				</div>
				<div>
					<Typography variant="bodySmBold"
						semanticTag="h4"
						className={"mb-0"}>
						{t("Preis")}
					</Typography>
					<Typography variant="bodySm"
						semanticTag="span">
						{priceRange}
					</Typography>
				</div>
			</div>
		</>}
	</div>

	)
}

export default VerticalSectionPlanFilters
